export default class ShopProductSellingPlan extends HTMLElement {
    private open = false
    // private selected: boolean = false

    private labels: HTMLLabelElement[] = []
    private list: HTMLUListElement
    private caret: HTMLSpanElement

    constructor() {
        super()

        this.open = this.getAttribute('open') === 'true'

        this.list = this.querySelector('[data-list]')!

        this.labels = Array.from(this.querySelectorAll('label[data-label]'))
        this.caret = this.querySelector('[data-caret]')!
    }

    connectedCallback() {
        if (this.labels) {
            this.labels.forEach((label) => {
                label?.addEventListener('click', this.handleLabelClick.bind(this))
            })
        }

        ;(window as any).addEventListener('selling-plan:open', this.handleSellingPlanOpen.bind(this))
        document.addEventListener('click', this.handleOutsideClick.bind(this))
    }

    set isOpen(value: boolean) {
        this.open = value
        this.toggle()
    }

    get isOpen() {
        return this.open
    }

    private handleSellingPlanOpen = (evt: CustomEvent) => {
        const { open } = evt.detail

        console.log('selling plan', open, evt)

        this.isOpen = open
    }

    private handleLabelClick = (evt: Event) => {
        evt.stopPropagation()

        this.isOpen = !this.isOpen

        if (this.isOpen) {
            return
        }

        const target = evt.target as HTMLInputElement

        const sellingPlanId = target.getAttribute('data-selling-plan-id')

        // update the list and put the selected item in at the top
        const selectedItem = this.list.querySelector(`[data-item-value="${sellingPlanId}"]`)

        const name = target.getAttribute('data-selling-plan-name')

        window.dispatchEvent(new CustomEvent('selling-plan:toggle', { detail: { isOriginal: false, name } }))

        if (selectedItem) {
            // this.list.insertBefore(selectedItem, this.list.firstChild)
            setTimeout(() => {
                this.isOpen = false
            }, 100)

            return
        }
    }

    private toggle() {
        // update the attributes
        console.log('toggle', this.isOpen)

        this.setAttribute('open', this.isOpen ? 'true' : 'false')
        this.list.setAttribute('data-open', this.isOpen ? 'true' : 'false')

        if (this.isOpen) {
            this.classList.remove('hidden')
            this.classList.add('!z-50')
            this.list.classList.add('!h-auto')
            this.caret.classList.add('rotate-180')
        } else {
            this.classList.add('hidden')
            this.classList.remove('!z-50')
            this.list.classList.remove('!h-auto')
            this.caret.classList.remove('rotate-180')
            this.list.scrollTo({ top: 0 })
        }
    }

    private handleOutsideClick = (evt: MouseEvent) => {
        if (!this.isOpen) return

        const target = evt.target as HTMLElement

        const isSellingPlan = target.getAttribute('id')?.includes('selling_plan')

        if (!this.contains(target) && !isSellingPlan) {
            this.isOpen = false
        }
    }
}

customElements.define('shop-product-selling-plan', ShopProductSellingPlan)
